/** Browser switch can only override the location-wide setting off, never independently on. */
export const resolveOverrideOffSetting = (forLocation: boolean, browserOverride: boolean | undefined): boolean =>
  forLocation && browserOverride !== false;

/** Browser switch wins when set, else falls back to the location-wide setting. */
export const resolveIndependentSetting = (forLocation: boolean, browserOverride: boolean | undefined): boolean =>
  browserOverride ?? forLocation;
